import React, { useState, useEffect } from "react";
import {
    Button, FormGroup,
} from "reactstrap";
import ApiCaller from "../../../../api/apiCaller";

interface ScanningPeriodItemProps {
    scanningPeriod?:any
}

const ScanningPeriod = ({
    scanningPeriod,
}: ScanningPeriodItemProps) => {
    const [scanningPeriodData, setScanningPeriodData] = useState<any>({
        ...scanningPeriod
    });
    const endScanningPeriod = async () => {
        const dataToSubmit = {
            ...scanningPeriodData,
            to_date: new Date(),
        };
        const res = await ApiCaller.post(
            'traffic_scan_period/',
            dataToSubmit
        );
        if (res.result) {
            setScanningPeriodData(res.result);
        }
    }
    const getScanResult = async () => {
        const res = await ApiCaller.get(`traffic_scan_period/${scanningPeriodData.id}/result`);
        if (res.result) {
            setScanningPeriodData({
                ...scanningPeriodData,
                results: res.result?.results,
            })
        }
    }
    return (
        <div style={styles.container}>
            <p style={styles.name}>
                {`${scanningPeriodData.name} - `}
                <span style={styles.uiLink}><a href="http://192.168.8.100:8080/" target="_blank" rel="noreferrer">
                    Truy cập link đo
                </a></span>
            </p>
            <div style={styles.info}>
                <span>{scanningPeriodData.description}</span><br />
                <span>Đo bằng: {scanningPeriodData.device?.unique_device_code}</span><br />
                <span>Bắt đầu đo: {scanningPeriodData.from_date}</span><br />
                <span>Kết thúc đo: {scanningPeriodData.to_date}</span>
                <div style={styles.actionDiv}>
                    {!scanningPeriodData.to_date &&
                        <Button
                            outline
                            size="sm"
                            color="primary"
                            onClick={endScanningPeriod}
                        >
                            Kết thúc
                        </Button>
                    }{' '}
                    <Button
                        outline
                        size="sm"
                        color="primary"
                        onClick={getScanResult}
                    >
                        Xem kết quả
                    </Button>
                </div>
            </div>
            {scanningPeriodData.results &&
                <div style={styles.countingResult}>
                    <p>Kết quả</p>
                    <ul>
                        {scanningPeriodData.results.map((result:any, index) =>
                            <li key={index}>{result.name}: {result.number_of_vehicles}</li>
                        )}
                    </ul>
                </div>
            }
        </div>
    );
}

const styles = {
    container: {
        padding: 12,
        borderBottom: '1px solid var(--color-line)',
    },
    name: {
        fontWeight: 700,
    },
    uiLink: {},
    info: {
        fontSize: 12,
    },
    actionDiv: {
        marginTop: 12,
    },
    countingResult: {
        marginTop: 12,
    },
};

export default ScanningPeriod;